import { render, staticRenderFns } from "./MemberCaipanList.vue?vue&type=template&id=716c4141&"
import script from "./MemberCaipanList.vue?vue&type=script&lang=js&"
export * from "./MemberCaipanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports